"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ProductFlags = /** @class */ (function (_super) {
    __extends(ProductFlags, _super);
    function ProductFlags() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductFlags.prototype.render = function () {
        var _this = this;
        return this.props.items && this.props.items.length ? (React.createElement("div", { className: this.props.className }, this.props.items.map(function (item, index) {
            var content = item;
            return !_this.props.limit || index < _this.props.limit ? (React.createElement("div", { key: index, className: "flex items-center justify-start ie-product-flag" },
                React.createElement("p", { className: (_this.props.size ? _this.props.size : "text-sm") + " text-red font-semibold" }, content))) : null;
        }))) : (React.createElement("div", { className: this.props.className + " " + (this.props.size ? this.props.size : "text-sm") }, "\u00A0"));
    };
    return ProductFlags;
}(React.PureComponent));
exports.ProductFlags = ProductFlags;
